import { Template } from './template';

export class Size {
  id: number;
  name: string;
  size_id: number;
  size_name: string;
  cards: Template[];
}



// WEBPACK FOOTER //
// /app/src/app/_models/size.ts